export interface SectionOrnamentProps {
  /** Mirror the run so a pair can flank a heading without the diamonds crowding it. */
  reverse?: boolean;
}

/**
 * A delicate celestial rule that trails a section heading: a long hairline, a
 * four-point star, a short hairline and two diamonds — deliberately asymmetric
 * so it reads as ornament rather than a divider.
 *
 * Purely decorative; it flips with the document direction along with the
 * heading it follows.
 */
export function SectionOrnament({ reverse = false }: SectionOrnamentProps): JSX.Element {
  return (
    <span className={`ornament${reverse ? ' ornament--reverse' : ''}`} aria-hidden="true">
      <span className="ornament__rule ornament__rule--long" />
      <svg className="ornament__star" viewBox="0 0 24 24" fill="currentColor" focusable="false">
        <path d="M12 3c.6 5.4 3.6 8.4 9 9-5.4.6-8.4 3.6-9 9-.6-5.4-3.6-8.4-9-9 5.4-.6 8.4-3.6 9-9Z" />
      </svg>
      <span className="ornament__rule ornament__rule--short" />
      <span className="ornament__diamond" />
      <span className="ornament__diamond ornament__diamond--sm" />
    </span>
  );
}
